// extracted by mini-css-extract-plugin
module.exports = {"root":"J_bj","full-width":"J_cC","fullWidth":"J_cC"};